import { handleActions } from 'redux-actions'
import {
  routeToHome,
  routeToOnDemand,
  routeToInstalledAgent,
  routeToClassroomAgent,
  routeToClassroomAgentReset,
  routeToDisconnect,
} from '../actions/routing'
import { NOT_FOUND } from 'redux-first-router'

const initialState = {
  sessionKey: null,
  id: null,
  current: null,
  urlToken: null,
}

export const routerReducer = handleActions({
  [routeToHome] (prevState, action) {
    return {
      ...prevState,
      current: action.type,
    }
  },
  [routeToOnDemand] (prevState, action) {
    return {
      ...prevState,
      sessionKey: action.payload.sessionKey,
      current: action.type,
    }
  },
  [routeToInstalledAgent] (prevState, action) {
    return {
      ...prevState,
      id: action.payload.id,
      current: action.type,
    }
  },
  [routeToClassroomAgent] (prevState, action) {
    const urlToken = action.meta && action.meta.query && action.meta.query.token ? action.meta.query.token : null
    return {
      ...prevState,
      id: action.payload.id,
      current: action.type,
      urlToken,
    }
  },
  [routeToClassroomAgentReset] (prevState) {
    return {
      ...prevState,
      urlToken: null,
    }
  },
  [routeToDisconnect] (prevState, action) {
    return {
      ...prevState,
      current: action.type,
    }
  },
  [NOT_FOUND] (prevState) {
    return {
      ...prevState,
      current: routeToDisconnect().type,
    }
  },
}, initialState)
